<template>
  <div class="">
    <div class="list-group">
      <div class="list-group-item list-group-item-action p-2" v-for="(abstract, index) in initialAbstracts"
           v-bind:key="index">
        <div class="row d-flex">
          <div class="col-6 col-sm-1 col-md-2 col-lg-1 my-auto mx-auto text-center" v-if="abstract.status_id === 1">
            <icon :icon="['fad', 'envelope-open-text']" class="fa-2x"/>
            <div class="text-warning">{{ wording[0].home.draft }}</div>
          </div>
          <div class="col-6 col-sm-1 col-md-2 col-lg-1 my-auto mx-auto text-center"
               v-if="abstract.status_id === 2 || abstract.status_id === 7">
            <icon :icon="['fad', 'envelope']" class="fa-2x"/>
            <div class="text-success">{{ wording[0].home.submitted }}</div>
          </div>
          <div class="col-6 col-sm-1 col-md-2 col-lg-1 my-auto mx-auto text-center" v-if="abstract.status_id === 3">
            <icon :icon="['fad', 'check']" class="fa-2x text-success"/>
            <div class="text-success">{{ wording[0].home.accepted }}</div>
          </div>
          <div class="col-6 col-sm-1 col-md-2 col-lg-1 my-auto mx-auto text-center" v-if="abstract.status_id === 6">
            <icon :icon="['fal', 'minus-circle']" class="fa-2x"/>
            <div class="text-warning">{{ wording[0].home.rejected }}</div>
          </div>
          <div class="col-6 col-sm-1 col-md-2 col-lg-1 my-auto mx-auto text-center" v-if="abstract.status_id === 9">
            <icon :icon="['fad', 'ban']" class="fa-2x"/>
            <div class="text-warning">{{ wording[0].home.withdrawn }}</div>
          </div>
          <div class="w-100 d-block d-sm-none"></div>
          <div class="col">
            <div class="row">
              <div class="col smaller">{{ abstract.reference_number }}</div>
            </div>
            <div class="row">
              <div class="col">
                <router-link v-if="abstract.title && abstract.status_id ===  1 && isOpen"
                             :to="'abstract/' + abstract.id + '/dynamic/' + getFirstCurrentPage(submission_id).id">
                  <div class="font-weight-bold" v-html="abstract.title"></div>
                </router-link>
                <router-link v-else
                             :to="'abstract/' + abstract.id + '/preview'">
                  <div v-if="abstract.title" class="font-weight-bold" v-html="abstract.title"></div>
                  <div class="text-danger" v-else>
                    <icon :icon="['fad', 'exclamation-circle']"/>
                    No title entered
                  </div>
                </router-link>
              </div>
            </div>
            <div class="row" v-if="getSettings(submission_id).abstracttable.showtype && submissions.find(item => item.id === submission_id).showOnlineConfirmation === false">
              <div class="col">
                <span class="">{{ wording[submission_id].submit.form_prestype }}:&nbsp;</span> <span v-for="type in types"
                                                        v-if="abstract.type_id === type.id">{{ type.name }}</span>
              </div>
            </div>
          </div>
          <div class="w-100 d-none d-xs-block"></div>
          <div class="col-12 col-sm-4"
               v-if="submissions.find(item => item.id === submission_id).showOnlineConfirmation === false">
            <div class="row">
              <div class="col d-flex">
                <PreviewArea :abstract="abstract" :wording="wording"/>
              </div>
              <div class="col d-flex">
                <button class="btn btn-link mx-auto"
                        v-if="(abstract.status_id === 1 || abstract.status_id === 2) &&  isOpen && submissions.find(item => item.id === submission_id).access_code && submissions.find(item => item.id === submission_id).access_code.length > 0"
                        v-on:click="openAccessCodeEdit(submission_id, abstract.id);">
                  <icon :icon="['fad', 'pencil-alt']" class="text-warning"/>
                  <br>
                  {{ wording[0].buttons.finalsubmit }}
                </button>
                <router-link tag="button"
                             :to="'abstract/' + abstract.id + '/dynamic/' + getFirstCurrentPage(submission_id).id"
                             class="btn btn-link mx-auto"
                             v-else-if="abstract.status_id == 1 && isOpen">
                  <icon :icon="['fad', 'pencil-alt']" class="text-warning"/>
                  <br>
                  {{ wording[0].buttons.edit }}
                </router-link>
                <button class="btn btn-link mx-auto"
                        v-else-if="abstract.status_id === 2 && getSettings(submission_id).resettoedit === true && isOpen"
                        v-on:click="resetToEditModal(abstract)">
                  <icon :icon="['fad', 'pencil-alt']" class="text-warning"/>
                  <br>
                  {{ wording[0].buttons.finalsubmit }}
                </button>
                <button class="btn btn-link disabled mx-auto" v-else>
                  <icon :icon="['fad', 'pencil-alt']" class="disabled"/>
                  <br>
                  {{ wording[0].buttons.edit }}
                </button>
              </div>
              <div class="w-100 d-block d-sm-none"></div>
              <div class="col d-flex">
                <SubmitArea :abstract="abstract" :is-open="isOpen" :wording="wording"/>
              </div>
              <!--
              <div class="col d-flex">
                <DeleteArea :abstract="abstract" @check-delete="checkDelete"
                            :is-open="isOpen" :submission_id="submission_id" :wording="wording"/>
              </div>
              -->
            </div>
          </div>
          <div class="col-12 col-sm-3"
               v-if="submissions.find(item => item.id === submission_id).showOnlineConfirmation === true">
            <div class="row">
              <div class="col d-flex">
                <PreviewArea :abstract="abstract" :wording="wording"/>
              </div>
              <ConfirmArea :abstract="abstract" :submission_id="submission_id"
                           :submissions="submissions.find(item => item.id === submission_id)"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal DELETE-->
    <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog"
         aria-labelledby="deleteModalTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger" id="deleteModalTitle">{{ wording[0].home.modal_delete_title }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <Speaker submission_id="0" area="home" textkey="modal_delete_text"/>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ wording[0].buttons.abort }}</button>
            <button type="button"
                    v-on:click="deleteAbstract()"
                    class="btn btn-secondary"
                    data-dismiss="modal">{{ wording[0].buttons.delete }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Reset 2 EDIT-->
    <div class="modal fade" id="resettoeditModal" tabindex="-1" role="dialog"
         aria-labelledby="resettoeditModalTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger" id="resettoeditModalTitle">
              {{ wording[0].home.modal_resettoedit_title }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <Speaker submission_id="0" area="home" textkey="modal_resettoedit_text"/>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ wording[0].buttons.abort }}</button>
            <button type="button"
                    v-on:click="resetToEdit"
                    class="btn btn-success"
                    data-dismiss="modal">
              <icon :icon="['fad', 'pencil-alt']"/>&nbsp;{{ wording[0].buttons.finalsubmit }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import Speaker from "./helpers/Speaker";
import ConfirmArea from "./abstracttable/ConfirmArea";
import PreviewArea from "./abstracttable/PreviewArea";
import DeleteArea from "./abstracttable/DeleteArea";
import SubmitArea from "./abstracttable/SubmitArea";

export default {
  components: {SubmitArea, DeleteArea, PreviewArea, ConfirmArea, Speaker},
  props: ['initialAbstracts', 'submission_id', 'isOpen'],
  name: "AbstractsTable",
  methods: {
    ...mapActions([
      'CREATE_ABSTRACT', 'RESETTOEDIT_ABSTRACT'
    ]),
    checkDelete(abstract_id, submission_id) {
      this.$set(this.$store.state.cache, 'abstract_id', abstract_id);
      this.$set(this.$store.state.cache, 'submission_id', submission_id);
      $('#deleteModal').modal('show');
    },
    deleteAbstract() {
      this.$store.dispatch('DELETE_ABSTRACT', this.cache)
    },
    resetToEdit() {
      this.RESETTOEDIT_ABSTRACT(this.cache.abstract_id).then((response) => {
        this.$noty.success(this.wording[0].notify.save_success);
        this.$router.push('abstract/' + this.cache.abstract_id + '/dynamic/' + this.getFirstCurrentPage(this.cache.submission_id).id);
      }).catch((error) => {
        this.$noty.error(this.wording[0].notify.save_not_success);
      })
    },
    resetToEditModal(abstract) {
      this.$set(this.$store.state.cache, 'abstract_id', abstract.id);
      this.$set(this.$store.state.cache, 'submission_id', abstract.setting_submission_id);
      $('#resettoeditModal').modal('show');
    },
    openAccessCodeEdit(submission_id, abstract_id) {
      console.log(submission_id);
      console.log(abstract_id);
      this.$emit("openaccess" ,{submissionid:submission_id, abstractid:abstract_id});
    },

  },
  computed: {
    ...mapState([
      'status', 'types', 'wording', "cache", "submissions"
    ]),
    ...mapGetters([
      'getFirstCurrentPage', 'getSettings'
    ]),
  },
  data() {
    return {
      deleteItem: {},
      abstractItem: {}
    };
  }
}
</script>

<style scoped>
@media (min-width: 10em) {
  .card-deck > .card {
    width: 30%;
    flex-wrap: wrap;
    flex: initial;
  }
}
</style>
